<div class="min-h-full" style="background-color: #fafaf7;">

  <!-- Loading -->
  @if (isLoading()) {
    <div class="flex items-center justify-center min-h-[60vh]">
      <div class="flex flex-col items-center gap-5">
        <div class="relative w-12 h-12">
          <div class="absolute inset-0 rounded-full border-4 border-stone-200"></div>
          <div class="absolute inset-0 rounded-full border-4 border-t-primary-400 animate-spin"></div>
        </div>
        <p class="text-stone-600 font-medium text-sm">Chargement…</p>
      </div>
    </div>
  }

  @if (!isLoading()) {
    <div class="max-w-[1200px] mx-auto px-5 sm:px-8 py-8 space-y-6">

      <!-- Error -->
      @if (errorMessage()) {
        <div class="p-4 rounded-2xl bg-red-50 border border-red-100 text-sm text-red-700 flex items-center gap-3">
          <span class="material-icons text-base text-red-500">error_outline</span>
          {{ errorMessage() }}
        </div>
      }

      <!-- Table card -->
      <div class="bg-white rounded-3xl shadow-sm border border-stone-100 overflow-hidden">

        <!-- Search + filter bar -->
        <div class="px-6 py-4 border-b border-stone-100 flex items-center gap-3 flex-wrap">

          <!-- Search -->
          <div class="relative flex-1 min-w-0 max-w-sm">
            <svg class="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-stone-400 pointer-events-none" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
            </svg>
            @if (isFiltering()) {
              <div class="absolute right-3 top-1/2 -translate-y-1/2 w-3.5 h-3.5 border-2 border-stone-300 border-t-primary-400 rounded-full animate-spin"></div>
            }
            <input
              type="search"
              class="w-full bg-white border border-stone-200 text-stone-800 placeholder-stone-400 text-sm rounded-lg pl-11 pr-8 py-2 outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all"
              placeholder="Rechercher une actualité…"
              (input)="onSearch($any($event.target).value)"
            />
          </div>

          <!-- Status filter -->
          <select
            class="border border-stone-200 text-stone-700 text-sm rounded-lg pl-3 pr-8 py-2 outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all bg-white flex-shrink-0"
            [value]="selectedStatus()"
            (change)="onStatusFilter($any($event.target).value)">
            <option value="">Tous les statuts</option>
            <option value="ACTI">En ligne</option>
            <option value="INAC">Hors ligne</option>
          </select>

          <!-- Add button -->
          @if (permService.can('marketing', 'actualites', 'create')) {
            <button
              (click)="onAddNew()"
              class="inline-flex items-center gap-1.5 px-3 py-1.5 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors text-xs font-medium flex-shrink-0 ml-auto"
            >
              <span class="material-icons text-base">add</span>
              Nouvel article
            </button>
          }
        </div>

        <!-- Table -->
        <div class="overflow-x-auto">
          <table class="w-full text-sm" role="table">
            <thead>
              <tr class="border-b border-stone-100 bg-stone-50">
                <th class="px-3 py-3 text-left text-xs font-medium text-stone-500 uppercase tracking-wider w-[48px]">ID</th>
                <th class="px-2 py-3 text-left text-xs font-medium text-stone-500 uppercase tracking-wider w-[56px]">Image</th>
                <th class="px-4 py-3 text-left text-xs font-medium text-stone-500 uppercase tracking-wider">Titre</th>
<th class="px-4 py-3 text-left text-xs font-medium text-stone-500 uppercase tracking-wider w-[120px] hidden md:table-cell">Tags</th>
                <th class="px-2 py-3 text-left text-xs font-medium text-stone-500 uppercase tracking-wider w-[69px]">Date</th>
                <th class="px-4 py-3 text-left text-xs font-medium text-stone-500 uppercase tracking-wider w-[112px]">Statut</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-stone-50">

              @if (actualites().length === 0) {
                <tr>
                  <td colspan="6" class="px-6 py-16 text-center">
                    <div class="flex flex-col items-center gap-3">
                      <div class="w-14 h-14 rounded-3xl bg-stone-100 flex items-center justify-center">
                        <svg class="w-6 h-6 text-stone-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M12 7.5h1.5m-1.5 3h1.5m-7.5 3h7.5m-7.5 3h7.5m3-9h3.375c.621 0 1.125.504 1.125 1.125V18a2.25 2.25 0 01-2.25 2.25M16.5 7.5V18a2.25 2.25 0 002.25 2.25M16.5 7.5V4.875c0-.621-.504-1.125-1.125-1.125H4.125C3.504 3.75 3 4.254 3 4.875V18a2.25 2.25 0 002.25 2.25h13.5" />
                        </svg>
                      </div>
                      <p class="text-stone-500 text-sm font-medium">Aucune actualité trouvée</p>
                      <p class="text-stone-400 text-xs">Créez votre premier article en cliquant sur "Nouvel article"</p>
                    </div>
                  </td>
                </tr>
              }

              @for (actualite of actualites(); track actualite.news_id) {
                <tr class="hover:bg-stone-50 transition-colors duration-150 group cursor-pointer"
                  [class.opacity-60]="actualite.news_status === 'INAC'"
                  (click)="onView(actualite.news_id)">
                  <!-- ID -->
                  <td class="px-3 py-3 w-[48px]">
                    <span class="text-xs font-mono text-stone-400">#{{ actualite.news_id }}</span>
                  </td>

                  <!-- Image -->
                  <td class="px-2 py-2 w-[56px]">
                    <div class="w-full h-10 rounded-xl overflow-hidden bg-stone-100 flex items-center justify-center flex-shrink-0 relative">
                      @if (actualite.file_link) {
                        <!-- Blurred background -->
                        <img
                          [src]="actualite.file_link"
                          aria-hidden="true"
                          class="absolute inset-0 w-full h-full object-cover blur-sm scale-110 opacity-60"
                        />
                        <!-- Sharp foreground -->
                        <img
                          [src]="actualite.file_link"
                          [alt]="actualite.news_name"
                          class="relative z-10 h-full w-auto object-contain"
                          (error)="onImageError($event)"
                        />
                      } @else {
                        <svg class="w-5 h-5 text-stone-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5H3.75A1.5 1.5 0 002.25 6v12a1.5 1.5 0 001.5 1.5zm10.5-11.25h.008v.008h-.008V8.25zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z" />
                        </svg>
                      }
                    </div>
                  </td>

                  <!-- Titre -->
                  <td class="px-4 py-3 w-[224px] max-w-[224px]">
                    <p autoDir class="font-semibold text-stone-800 text-xs truncate">{{ actualite.news_name }}</p>
                  </td>

                  <!-- Tags -->
                  <td class="px-4 py-3 w-[120px] hidden md:table-cell">
                    <app-tag-chips [value]="actualite.news_tags" [max]="2"></app-tag-chips>
                    @if (!actualite.news_tags) {
                      <span class="text-xs text-stone-300">—</span>
                    }
                  </td>

                  <!-- Date -->
                  <td class="px-2 py-3 w-[69px] whitespace-nowrap">
                    <span class="text-xs text-stone-500 font-mono">
                      {{ actualite.news_begin_date ? (actualite.news_begin_date | date:'dd/MM/yy') : '—' }}
                    </span>
                  </td>

                  <!-- Statut -->
                  <td class="px-4 py-3 w-[112px]">
                    <span class="inline-flex items-center gap-1.5 text-xs font-medium px-2.5 py-1 rounded-full border whitespace-nowrap"
                      [class]="statusBadgeClass(actualite.news_status)">
                      <span class="w-1.5 h-1.5 rounded-full flex-shrink-0"
                        [class]="actualite.news_status === 'ACTI' ? 'bg-emerald-500' : 'bg-amber-400'"></span>
                      {{ actualite.news_status_label || statusLabel(actualite.news_status) }}
                    </span>
                  </td>

                </tr>
              }

            </tbody>
          </table>
        </div>
      </div>

      <!-- Pagination -->
      @if (pagination().totalPages > 1) {
        <div class="flex items-center justify-between">
          <p class="text-xs text-stone-400">
            Page <span class="font-semibold text-stone-600">{{ pagination().page }}</span> sur
            <span class="font-semibold text-stone-600">{{ pagination().totalPages }}</span>
            · <span class="font-semibold text-stone-600">{{ pagination().total }}</span> articles
          </p>
          <div class="flex items-center gap-1">
            <button type="button"
              (click)="onPageChange(pagination().page - 1)"
              [disabled]="pagination().page === 1"
              class="w-8 h-8 rounded-xl flex items-center justify-center text-stone-500 hover:bg-stone-100 disabled:opacity-30 disabled:cursor-not-allowed transition-colors">
              <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
              </svg>
            </button>

            @for (p of pageNumbers(); track p) {
              @if (p === '...') {
                <span class="w-8 h-8 flex items-center justify-center text-xs text-stone-400">…</span>
              } @else {
                <button type="button"
                  (click)="onPageChange($any(p))"
                  class="w-8 h-8 rounded-xl text-xs font-medium transition-colors"
                  [class]="$any(p) === pagination().page
                    ? 'bg-primary-600 text-white shadow-sm'
                    : 'text-stone-500 hover:bg-stone-100'">
                  {{ p }}
                </button>
              }
            }

            <button type="button"
              (click)="onPageChange(pagination().page + 1)"
              [disabled]="pagination().page === pagination().totalPages"
              class="w-8 h-8 rounded-xl flex items-center justify-center text-stone-500 hover:bg-stone-100 disabled:opacity-30 disabled:cursor-not-allowed transition-colors">
              <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
              </svg>
            </button>
          </div>
        </div>
      }

    </div>
  }
</div>

